import { Order } from '../Order/Order';
import { cities, statesByCity } from '../../constants/Address';

export interface Address {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  city: string;
  county: string;
  state: string;
  zip?: string;
  address1: string;
  address2?: string;
  taxNo?: string;
  taxOffice?: string;
  addressType: string;
}

export const addressFromResponse = (responseData: any): Address => ({
  id: responseData.id,
  firstName: responseData.first_name,
  lastName: responseData.last_name,
  fullName: responseData.full_name,
  city: responseData.city,
  county: responseData.county,
  state: responseData.state,
  zip: responseData.zip,
  address1: responseData.address_1,
  address2: responseData.address_2,
  taxNo: responseData.vergi_no,
  taxOffice: responseData.vergi_dairesi,
  addressType: responseData.address_type,
});

export const addressesFromOrder = (
  order: Order,
): { shipping: Address; billing: Address } => ({
  shipping: {
    id: 0,
    firstName: order.shippingFirstName,
    lastName: order.shippingLastName,
    fullName: `${order.shippingFirstName} ${order.shippingLastName}`,
    city: '',
    county: '',
    state: '',
    address1: order.shippingAddress,
    addressType: '0',
  },
  billing: {
    id: 0,
    firstName: order.billingFirstName,
    lastName: order.billingLastName,
    fullName: `${order.billingFirstName} ${order.billingLastName}`,
    city: '',
    county: '',
    state: '',
    address1: order.billingAddress,
    addressType: '0',
  },
});

export const addressOutputTransformer = (address: Address) => ({
  first_name: address.firstName,
  last_name: address.lastName,
  city: address.city,
  state: address.state,
  zip: address.zip,
  address_1: address.address1,
  vergi_no: address.taxNo,
  vergi_dairesi: address.taxOffice,
  address_type: address.addressType,
});

export const getEmptyAddress = (): Address => ({
  id: 0,
  firstName: '',
  lastName: '',
  fullName: '',
  city: cities[0],
  county: 'Türkiye',
  state: statesByCity[cities[0]][0],
  address1: '',
  addressType: '0',
});
